import firebase from "firebase";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCHJgAjjECjnIj9VB88k4Kb5rrEFQzC84g",
    authDomain: "clone-aeb05.firebaseapp.com",
    databaseURL: "https://clone-aeb05.firebaseio.com",
    projectId: "clone-aeb05",
    storageBucket: "clone-aeb05.appspot.com",
    messagingSenderId: "737316991586",
    appId: "1:737316991586:web:9d902721e98e4789f1573b",
    measurementId: "G-88BQQF4XB3"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth =firebase.auth();

  export {db,auth}